import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { CITIES } from '../constants'

const deleteCity = async (id: number) => {
  await fetchAPI({
    path: `/cities/${id}`,
    method: 'delete',
  })
}

export const useDeleteCity = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteCity, {
    async onSuccess() {
      await queryClient.refetchQueries([CITIES])

      toast({
        description: t('views.admin.cities.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
